/* External Imports */
import { Box, Image, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import ProgramListCard from '@app-ps/Components/Card/ProgramListCard'; // Import the new component
import config from '@config';
/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */
const ProgramsList = ({ sectionContent, region, lang }) => {
  const structuredText = sectionContent.find(
    item => item._modelApiKey === 'structured_text'
  );
  const linkedPrograms =
    sectionContent.find(item => item._modelApiKey === 'ps_linked_program')
      ?.linkedProgram || [];

  return (
    <Box
      width={'100%'}
      pt={{ base: '25%', md: '2rem', lg: '8rem' }}
      pb={{ base: '2rem', lg: '4rem', xl: '0', '2xl': '7rem' }}
      bg={'black'}
      position={'relative'}
    >
      <Box
        position="absolute"
        top={{ md: '0rem', base: '3rem', lg: '-1%' }}
        right={{ base: '2rem', lg: '0rem', '2xl': '5%' }}
        width={{ base: '4.5rem', md: '100px', lg: '124px', '2xl': '155px' }}
        display={{ base: 'none', lg: 'block' }}
        height={{ base: '189px', md: '293px', lg: '496px', '2xl': '621px' }}
        m="10px"
      >
        <Image
          src={`${config.imgPath}/d/46272/1726566828-single-kolam.png`}
          alt="Top Right Image"
          width="100%"
          height="100%"
          objectFit="cover"
        />
      </Box>

      <Box
        ml={{
          base: '1rem',
          md: '6.25rem',
          lg: '2rem',
          xl: '0',
          '2xl': '13rem',
        }}
        mr={{
          base: '1rem',
          md: '6.25rem',
          lg: '12rem',
          xl: '10%',
          '2xl': '13rem',
        }}
      >
        <Text
          // display={{ base: 'flex' }}
          // gap={{ base: '0.375rem', md: '0.5rem' }}
          justifyContent={{ base: 'center' }}
          fontFamily="var(--FedraSerifDisplay-Bold)"
          // alignItems={{ base: 'center' }}
          textAlign={{ base: 'left', md: 'center' }}
          fontSize={{ md: '2.25rem', base: '1.5rem' }}
          letterSpacing={'0.16px'}
          lineHeight={{ md: '2.7rem', base: '1.8rem' }}
          mb={{ lg: '5rem' }}
        >
          {structuredText?.body.value.document.children[0].children.map(
            (span, index) => (
              <Text
                key={index}
                as="span"
                fontWeight={span.marks?.includes('strong') ? '700' : '400'}
                color={
                  span.marks?.includes('highlight') ? '#EDA807' : '#FEFAF6'
                }
              >
                {span.value}
              </Text>
            )
          )}
        </Text>
        {linkedPrograms.map((program, index) => (
          <ProgramListCard // Use ProgramListCard here
            key={index}
            program={program}
            region={region}
            lang={lang}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ProgramsList;
